import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import { testimonials as mockTestimonials, type Testimonial } from "@/mocks/testimonials";

interface DbTestimonial {
  id: string;
  name: string;
  location: string | null;
  rating: number | null;
  content: string;
}

function toTestimonial(t: DbTestimonial): Testimonial {
  return {
    id: t.id,
    name: t.name,
    location: t.location || "Australia",
    rating: t.rating ?? 5,
    content: t.content,
  };
}

export function useTestimonials(): Testimonial[] {
  const [items, setItems] = useState<Testimonial[]>(mockTestimonials);

  useEffect(() => {
    let active = true;
    supabase
      .from("testimonials")
      .select("*")
      .is("deleted_at", null)
      .order("created_at", { ascending: false })
      .then(({ data, error }) => {
        if (!active) return;
        if (error || !data || data.length === 0) {
          setItems(mockTestimonials);
        } else {
          setItems((data as DbTestimonial[]).map(toTestimonial));
        }
      });

    return () => {
      active = false;
    };
  }, []);

  return items;
}